import { BadgeId, BadgesStats } from '../Models';
import { WritingBadge } from './WritingBadge';

export default class SneakerBadge extends WritingBadge {
  public readonly id = BadgeId.sneaker;

  public evaluateIfAchieved = (stats: BadgesStats) => {
    return stats.pagesCount >= 11;
  };
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/sneaker.ts